export enum EError {
  REQUIRED = 'required',
  MAX = 'max',
  MIN = 'min',
  MIN_LENGTH = 'minlength',
  MAX_LENGTH = 'maxlength',
  DECIMAL_PRECISION = 'decimalPrecision',
  POSTAL_CODE = 'postalCode',
  ALPHABET_ONLY = 'alphabetOnly',
  NUMBER_ONLY = 'numberOnly',
  ALPHANUMERIC_SPACE = 'alphaNumericSpace',
  COMPARE_VALIDATION = 'compareValidator',
  VALUE_GREATERTHAN_MAX = 'valueIsGreaterThanMax',
    VALUE_GREATERTHAN_EQUALTO_MAX = 'valueIsGreaterThanEqualToMax',
    VALUE_LESSTHAN_MIN = 'valueIsLessThanMin',
    VALUE_LESSTHAN_EQUALTO_MIN = 'valueIsLessThanEqualToMin'
}
